var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Asesor")]),_c('th',[_vm._v("Solicitudes")]),_c('th',[_vm._v("Solicitudes Netas")]),_c('th',[_vm._v("% Solicitudes netas")]),_c('th',[_vm._v("Propuestas aceptadas")]),_c('th',[_vm._v("File Comercial")]),_c('th',[_vm._v("Aprobados")]),_c('th',[_vm._v("Clientes")])])])
}]

export { render, staticRenderFns }